import {createFileRoute} from "@tanstack/react-router";
import {z as zod} from "zod";
import {generateOidcAuthenticationParameters} from "~/utilities/oidcAuthentication";
import {storePostLoginRedirectPathForOidcState} from "~/utilities/postLoginRedirect";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";

const OIDC_CODE_VERIFIER_KEY = "oidc_code_verifier";
const OIDC_STATE_KEY = "oidc_state";

export const Route = createFileRoute("/_withAuthenticationStatus/_notAuthenticated/impersonate")({
    validateSearch: zod.object({
        ticket: zod.string(),
    }),
    beforeLoad: async ({context, search}) => {
        const {codeChallenge, codeVerifier, state} = await generateOidcAuthenticationParameters();

        sessionStorage.setItem(OIDC_CODE_VERIFIER_KEY, codeVerifier);
        sessionStorage.setItem(OIDC_STATE_KEY, state);
        storePostLoginRedirectPathForOidcState({
            intellsysBaseUrl: context.intellsysBaseUrl,
            redirectPath: "/u",
            state: state,
        });

        const impersonationStartUrl = new URL("/oauth/impersonation/start", context.oidcAuthorizeBaseUrl);
        impersonationStartUrl.searchParams.set("client_id", context.oidcClientId);
        impersonationStartUrl.searchParams.set("code_challenge", codeChallenge);
        impersonationStartUrl.searchParams.set("code_challenge_method", "S256");
        impersonationStartUrl.searchParams.set("redirect_uri", `${context.intellsysBaseUrl}/auth-callback`);
        impersonationStartUrl.searchParams.set("response_type", "code");
        impersonationStartUrl.searchParams.set("scope", "openid offline_access profile");
        impersonationStartUrl.searchParams.set("state", state);
        impersonationStartUrl.searchParams.set("ticket", search.ticket);

        window.location.href = impersonationStartUrl.toString();

        return new Promise<never>(() => {});
    },
    loader: async () => {},
    errorComponent: ErrorComponent,
    notFoundComponent: NotFoundComponent,
    pendingComponent: PendingComponent,
});
